import {clickEvent} from "../../../webpack/modules/events";
import {hideLoader, renderCart, showLoader} from "../../../webpack/modules-optimized/cart";

clickEvent('header .open-cart', false, async function() {
    let cart = document.querySelector('#cart');
    if (!cart.classList.contains('new-cart')) cart.classList.add('new-cart');
    let offcanvas = Offcanvas.getOrCreateInstance(cart);

    offcanvas.show();
    showLoader();
    import(/* webpackChunkName: "header-cart-general" */ '../../Cart/General/main');
    import(/* webpackChunkName: "header-cart-item-general" */ '../../Cart/Item/General/main');
    import(/* webpackChunkName: "header-cart-item-image-zoom" */ '../../Cart/Item/ImageZoom/main');
    import(/* webpackChunkName: "header-cart-voucher" */ '../../Cart/Voucher/main');
    await renderCart();
    hideLoader();
});